<form (submit)="sign()" novalidate>
    @if (signResponse) {
        <div class="ap-digicode>">
            <div class="ap-grid ap-padding-bottom-2 ap-gap-3">
                <div>
                    @if (anonymous) {
                        <ap-input
                            [label]="'digicode.username' | apContent"
                            data-bb="username"
                            [formControl]="signResponse.get('keyID') | apFormControl"
                            [messages]="keyIdErrorMessages"
                        >
                        </ap-input>
                    } @else {
                        <dl [display]="keyValueDisplay.stacked" data-bb="username">
                            <dt>{{ 'digicode.username' | apContent }}</dt>
                            <dd>{{ keyIDs[0] }}</dd>
                        </dl>
                    }
                </div>
                <div>
                    <ap-password-input
                        [formControl]="signResponse.get('response') | apFormControl"
                        [label]="'digicode.password' | apContent"
                        data-bb="password"
                        [messages]="passwordErrorMessages"
                    >
                    </ap-password-input>
                </div>
            </div>
            @if (saveTokenIdEnabled()) {
                <div>
                    <ap-checkbox [label]="'digicode.username.save' | apContent" [formControl]="saveUsername"></ap-checkbox>
                </div>
            }
            <ng-container>
                <div class="ap-digicode__buttons">
                    @if (cancelText()) {
                        <ap-button data-bb="cancel" variant="secondary" (onClick)="cancel()">
                            {{ cancelText() }}
                        </ap-button>
                    }
                    <ap-submit [canSign]="canSign" [submitText]="submitText()" (submitted)="sign()"></ap-submit>
                </div>
            </ng-container>
        </div>
    }
</form>
